import journalModuleConfig from './journalModuleConfig'

export default journalModuleConfig
